import CryptoJS from 'crypto-js'

// 默认的 KEY 与 iv 如果没有给
const KEY = CryptoJS.enc.Utf8.parse('63eeac68cf074c8c')
const IV = CryptoJS.enc.Utf8.parse('63eeac68cf074c8c')
/**
 * AES加密 ：字符串 key iv  返回base64
 */
export function Encrypt(word, keyStr, ivStr) {
  let key = KEY
  let iv = IV
  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr)
    iv = CryptoJS.enc.Utf8.parse(ivStr)
  }
  // 手动进行ZeroPadding填充
  let wordBytes = CryptoJS.enc.Utf8.parse(word)
  let blockSize = 16 // AES block size
  let wordLength = wordBytes.sigBytes
  let paddingLength = blockSize - (wordLength % blockSize)

  // 如果需要填充，添加零字节
  if (paddingLength > 0 && paddingLength < blockSize) {
    let paddingBytes = CryptoJS.lib.WordArray.create([], paddingLength)
    wordBytes = wordBytes.concat(paddingBytes)
  }

  var encrypted = CryptoJS.AES.encrypt(wordBytes, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.NoPadding
  })
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}
/**
 * AES 解密 ：字符串 key iv  返回base64
 *
 * @return {string}
 */
export function Decrypt(word, keyStr, ivStr) {
  let key = KEY
  let iv = IV

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr)
    iv = CryptoJS.enc.Utf8.parse(ivStr)
  }

  const base64 = CryptoJS.enc.Base64.parse(word)
  const src = CryptoJS.enc.Base64.stringify(base64)

  const decrypt = CryptoJS.AES.decrypt(src, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.NoPadding
  })

  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  // 移除末尾的零字节（ZeroPadding）
  return decryptedStr.toString().replace(/\0+$/, '')
}
